export default "__VITE_ASSET__DsKlxg6Q__"